import type { FlowDto } from '@/types/dtos/flows/response/flow.dto';
import { resolveCueItemState } from '@/helpers/perform-staging.helper';
import type { FlowCueStateV1 } from '@/types/player/perform-control-v1.types';
import { isShowInfoCueRowFromFlow } from '@/helpers/show-info-advance.helper';

export function resolveLiveNextMediaStopCommand(
  flow: FlowDto,
  entityRef: string,
  cueState: FlowCueStateV1 | undefined,
): {
  action: 'stopMedia';
  entityRef: string;
  itemId: string;
  cueItemId?: string;
  scope?: string;
  slotId?: string;
} | null {
  if (!cueState) {
    return null;
  }

  const itemId = cueState.currentStep?.itemId;
  if (!itemId?.startsWith('media:')) {
    return null;
  }

  const scope = cueState.currentStep?.scope;
  const slotId =
    cueState.activeSlotId ??
    Object.values(cueState.items ?? {}).find((entry) => entry.isCurrent && entry.itemId === itemId)?.slotId;
  const cueItemId =
    (cueState.currentStep as { cueItemId?: string } | undefined)?.cueItemId ??
    Object.values(cueState.items ?? {}).find((entry) => entry.isCurrent && entry.itemId === itemId)?.cueItemId;

  const itemState = resolveCueItemState(cueState.items, itemId, { scope, slotId, cueItemId });
  if (itemState?.phase !== 'on_air') {
    return null;
  }

  if (
    !isShowInfoCueRowFromFlow(flow, {
      itemId,
      scope: itemState.scope ?? scope,
      slotId: itemState.slotId ?? slotId,
      segmentKind: cueState.activeSegmentKind ?? '',
      segmentAnchor: cueState.currentStep?.segmentAnchor ?? '',
      advanceSettings: cueState.currentRefSettings,
    })
  ) {
    return null;
  }

  return {
    action: 'stopMedia',
    entityRef,
    itemId,
    ...((itemState.cueItemId ?? cueItemId) ? { cueItemId: itemState.cueItemId ?? cueItemId } : {}),
    ...((itemState.scope ?? scope) ? { scope: itemState.scope ?? scope } : {}),
    ...((itemState.slotId ?? slotId) ? { slotId: itemState.slotId ?? slotId } : {}),
  };
}
